import React from 'react'
import PropTypes from 'prop-types'
import { string, isNotEmpty } from 'common/helpers'

import SubscriptionBlock from 'components/smartSearch/SubscriptionBlock/SubscriptionBlock'
import Sidebar from 'components/smartSearch/Sidebar/Sidebar'
import SidebarSection from 'components/smartSearch/SidebarSection/SidebarSection'
import SidebarTitle from 'components/smartSearch/SidebarTitle/SidebarTitle'
import FiltersContainer from 'components/smartSearch/FiltersContainer/FiltersContainer'
import ProductsFeed from 'components/smartSearch/ProductsFeed/ProductsFeed'
import Title from 'components/_new/typography/deprecated/Title/Title'
import Box from 'components/_new/layout/Box/Box'

import NoteSection from '../NoteSection/NoteSection'

import messages from '../messages'
import s from './ExceptMobile.scss'


const NoteExceptMobile = (props) => {
  const { gender, note, notes, products, productsAtPage, metadata } = props

  const isMale        = gender === 'male'
  const productTitle  = isMale ? messages.productTitle.male : messages.productTitle.female
  const noteName      = string.capitalize(note.name)

  return (
    <div className={s.container}>
      <Sidebar>
        <SubscriptionBlock metadata={metadata} />
        <SidebarSection>
          <SidebarTitle title={messages.notes} />
          <FiltersContainer>
            {
              notes
                .filter(({ [`${isMale ? 'colognes' : 'perfumes'}Count`]: count }) => count)
                .map(({ name, slug }, index) => {
                  const link = `/${slug}-${isMale ? 'colognes' : 'perfumes'}`

                  return (
                    <a key={index} className={s.link} href={link}>
                      {name}
                    </a>
                  )
                })
            }
          </FiltersContainer>
        </SidebarSection>
      </Sidebar>
      <div className={s.content}>
        <NoteSection {...note} gender={gender} />
        {
          isNotEmpty(products) && (
            <Box pt="36">
              <Box mb="24">
                <Title
                  className={s.sectionTitle}
                  tag="h2"
                  message={productTitle}
                  values={{ note: noteName }}
                />
              </Box>
              <ProductsFeed
                items={products}
                itemButtonTitle={messages.try}
                metadata={metadata}
                snowplowMetadata={metadata}
                limit={productsAtPage}
              />
            </Box>
          )
        }
      </div>
    </div>
  )
}

NoteExceptMobile.propTypes = {
  gender: PropTypes.string,
  note: PropTypes.object,
  products: PropTypes.array,
  productsAtPage: PropTypes.number,
  metadata: PropTypes.shape({
    placement: PropTypes.string.isRequired,
  }).isRequired,
}

export default NoteExceptMobile
